import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { Link, useParams } from 'react-router-dom';
import { useEffect, type CSSProperties } from 'react';
import { allArticles, type ArticleData } from '@/mocks/articleData';
import SEOHead from '@/components/base/SEOHead';
import JsonLd from '@/components/base/JsonLd';

const siteUrl = 'https://oopbuyspread.biz';

const headerStyles: Record<string, CSSProperties> = {
  'oopbuy-spreadsheet-guide': { backgroundImage: "url('https://readdy.ai/api/search-image?query=Clean%20minimalist%20product%20photography%20of%20luxury%20fashion%20accessories%20on%20warm%20ivory%20background%20featuring%20premium%20leather%20goods%20and%20shoes%20arranged%20harmoniously%20soft%20natural%20daylight%20gentle%20shadows%20editorial%20European%20aesthetic%20sophisticated%20modern%20composition%20high%20quality%20commercial%20look&width=800&height=500&seq=article-hdr-guide&orientation=landscape')" },
  'oopbuy-spreadsheet-anfaenger': { backgroundImage: "url('https://readdy.ai/api/search-image?query=A%20bright%20airy%20workspace%20desk%20with%20laptop%20notebook%20and%20stylish%20fashion%20sneakers%20placed%20alongside%20on%20warm%20cream%20studio%20backdrop%20soft%20natural%20lighting%20minimal%20editorial%20photography%20fresh%20modern%20European%20aesthetic%20clean%20composition&width=800&height=500&seq=article-hdr-anfaenger&orientation=landscape')" },
  'oopbuy-spreadsheet-versand': { backgroundImage: "url('https://readdy.ai/api/search-image?query=Cardboard%20shipping%20box%20with%20packing%20materials%20next%20to%20a%20pair%20of%20white%20sneakers%20on%20warm%20cream%20backdrop%20minimal%20studio%20setup%20soft%20natural%20light%20editorial%20product%20photography%20clean%20modern%20European%20look%20professional%20composition&width=800&height=500&seq=article-hdr-versand&orientation=landscape')" },
  'oopbuy-spreadsheet-qc-check': { backgroundImage: "url('https://readdy.ai/api/search-image?query=Magnifying%20glass%20examining%20a%20designer%20handbag%20in%20beige%20tone%20on%20warm%20cream%20studio%20background%20soft%20natural%20daylight%20minimal%20editorial%20composition%20quality%20inspection%20concept%20European%20aesthetic%20clean%20professional%20look&width=800&height=500&seq=article-hdr-qc&orientation=landscape')" },
  'oopbuy-spreadsheet-sicherheit': { backgroundImage: "url('https://readdy.ai/api/search-image?query=Padlock%20icon%20and%20shield%20symbol%20next%20to%20luxury%20fashion%20accessories%20on%20warm%20cream%20background%20soft%20natural%20lighting%20minimal%20editorial%20photography%20security%20trust%20concept%20clean%20modern%20European%20aesthetic%20professional&width=800&height=500&seq=article-hdr-sicherheit&orientation=landscape')" },
  'oopbuy-spreadsheet-coupons': { backgroundImage: "url('https://readdy.ai/api/search-image?query=Golden%20discount%20tags%20and%20fashion%20shopping%20bags%20with%20shoes%20on%20warm%20cream%20background%20soft%20natural%20lighting%20minimal%20editorial%20photography%20sale%20promotion%20concept%20clean%20modern%20European%20aesthetic&width=800&height=500&seq=article-hdr-coupons&orientation=landscape')" },
  'oopbuy-spreadsheet-vergleich': { backgroundImage: "url('https://readdy.ai/api/search-image?query=Side%20by%20side%20comparison%20of%20two%20different%20leather%20handbags%20in%20neutral%20tones%20on%20warm%20cream%20studio%20backdrop%20soft%20natural%20light%20minimal%20editorial%20photography%20versus%20concept%20clean%20modern%20European%20aesthetic&width=800&height=500&seq=article-hdr-vergleich&orientation=landscape')" },
  'oopbuy-spreadsheet-sneaker': { backgroundImage: "url('https://readdy.ai/api/search-image?query=Stylish%20white%20and%20beige%20designer%20sneakers%20arranged%20in%20a%20row%20on%20warm%20cream%20studio%20backdrop%20soft%20natural%20daylight%20minimal%20editorial%20product%20photography%20clean%20modern%20European%20aesthetic%20high%20detail&width=800&height=500&seq=article-hdr-sneaker&orientation=landscape')" },
  'oopbuy-spreadsheet-weidian': { backgroundImage: "url('https://readdy.ai/api/search-image?query=Smartphone%20screen%20displaying%20shopping%20app%20next%20to%20fashion%20accessories%20on%20warm%20cream%20desk%20soft%20natural%20lighting%20minimal%20editorial%20photography%20online%20shopping%20concept%20clean%20modern%20European%20aesthetic&width=800&height=500&seq=article-hdr-weidian&orientation=landscape')" },
  'oopbuy-spreadsheet-taobao': { backgroundImage: "url('https://readdy.ai/api/search-image?query=Open%20laptop%20displaying%20colorful%20fashion%20marketplace%20next%20to%20shopping%20bags%20and%20sandals%20on%20warm%20cream%20desk%20soft%20natural%20lighting%20minimal%20editorial%20photography%20ecommerce%20concept%20clean%20modern%20European%20aesthetic&width=800&height=500&seq=article-hdr-taobao&orientation=landscape')" },
};

const fallbackStyle: CSSProperties = { backgroundImage: "url('https://readdy.ai/api/search-image?query=Clean%20minimalist%20product%20photography%20with%20fashion%20accessories%20on%20warm%20ivory%20background%20soft%20natural%20daylight%20editorial%20European%20aesthetic&width=800&height=500&seq=article-hdr-fallback&orientation=landscape')" };

function buildArticleJsonLd(article: ArticleData, canonicalUrl: string) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: article.metaTitle,
    description: article.metaDescription,
    url: canonicalUrl,
    inLanguage: 'de-DE',
    datePublished: '2026-07-01',
    dateModified: '2026-07-16',
    author: {
      '@type': 'Organization',
      name: 'OOPBUY Redaktion',
      url: siteUrl,
    },
    publisher: {
      '@type': 'Organization',
      name: 'OOPBUY Spreadsheet',
      url: siteUrl,
      logo: {
        '@type': 'ImageObject',
        url: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/5133451b25e408e4a25e4df97e05add8.jpeg',
      },
    },
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': canonicalUrl,
    },
  };
}

export default function ArticlePage() {
  const { slug } = useParams<{ slug: string }>();
  const article: ArticleData | undefined = allArticles.find((a) => a.slug === slug);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [slug]);

  if (!article) {
    return (
      <>
        <SEOHead
          title="Artikel nicht gefunden – OOPBUY Spreadsheet"
          description="Der angeforderte Artikel wurde nicht gefunden. Kehren Sie zur OOPBUY Spreadsheet Startseite zurück."
          canonicalUrl={`${siteUrl}/artikel/${slug || ''}`}
          robots="noindex"
        />
        <Navbar />
        <main className="pt-20">
          <div className="max-w-[1440px] mx-auto px-4 md:px-10 py-20 text-center">
            <h1 className="text-2xl font-heading font-bold text-foreground-950 mb-4">Artikel nicht gefunden</h1>
            <p className="text-foreground-600 mb-6">Der angeforderte Artikel existiert leider nicht.</p>
            <Link to="/" className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-white text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap">
              Zur&uuml;ck zur Startseite
            </Link>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  const canonicalUrl = `${siteUrl}/artikel/${article.slug}`;
  const headerStyle = headerStyles[article.slug] || fallbackStyle;
  const articleJsonLd = buildArticleJsonLd(article, canonicalUrl);

  return (
    <>
      <SEOHead
        title={article.metaTitle}
        description={article.metaDescription}
        keywords={article.metaKeywords}
        canonicalUrl={canonicalUrl}
        ogType="article"
      />
      <JsonLd data={articleJsonLd} />
      <Navbar />
      <main>
        <article className="pt-20">
          <header className="bg-background-100 py-12 md:py-16">
            <div className="max-w-[1440px] mx-auto px-4 md:px-10">
              <div className="flex flex-col lg:flex-row gap-8 lg:gap-12 items-start">
                <div className="lg:w-[55%]">
                  <nav className="flex items-center gap-2 text-xs text-foreground-500 mb-4 flex-wrap" aria-label="Breadcrumb">
                    <Link to="/" className="hover:text-foreground-800 transition-colors">Startseite</Link>
                    <span className="w-3 h-3 flex items-center justify-center" aria-hidden="true">
                      <i className="ri-arrow-right-s-line"></i>
                    </span>
                    <Link to="/artikel/oopbuy-spreadsheet-guide" className="hover:text-foreground-800 transition-colors">Einkaufsführer</Link>
                    <span className="w-3 h-3 flex items-center justify-center" aria-hidden="true">
                      <i className="ri-arrow-right-s-line"></i>
                    </span>
                    <span className="text-foreground-400 truncate max-w-[200px]">{article.title.replace(/&[a-z]+;/g, '')}</span>
                  </nav>
                  <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight" dangerouslySetInnerHTML={{ __html: article.title }} />
                  <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed" dangerouslySetInnerHTML={{ __html: article.subtitle }} />
                  <div className="flex items-center gap-4 mt-6 text-xs text-foreground-500">
                    <span>Aktualisiert: Juli 2026</span>
                    <span className="w-1 h-1 rounded-full bg-foreground-300" aria-hidden="true" />
                    <span>Lesezeit: {article.readingTime}</span>
                    <span className="w-1 h-1 rounded-full bg-foreground-300" aria-hidden="true" />
                    <span>Von OOPBUY Redaktion</span>
                  </div>
                </div>
                <div className="lg:w-[40%]">
                  <div
                    className="w-full h-[240px] md:h-[300px] rounded-2xl bg-cover bg-center"
                    style={headerStyle}
                    role="img"
                    aria-label={`Titelbild für ${article.title.replace(/&[a-z]+;/g, '')}`}
                  />
                </div>
              </div>
            </div>
          </header>

          <div className="max-w-[1440px] mx-auto px-4 md:px-10 py-10 md:py-14">
            <div className="flex flex-col lg:flex-row gap-10 lg:gap-14">
              <aside className="lg:w-[240px] flex-shrink-0">
                <div className="sticky top-24 bg-background-100 rounded-xl p-5 border border-background-200/60">
                  <h3 className="text-sm font-heading font-bold text-foreground-950 mb-3">
                    Inhaltsverzeichnis
                  </h3>
                  <nav className="flex flex-col gap-2" aria-label="Inhaltsverzeichnis">
                    {article.sections.map((section) => (
                      <a
                        key={section.id}
                        href={`#${section.id}`}
                        className="text-xs text-foreground-600 hover:text-primary-600 transition-colors leading-relaxed"
                      >
                        {section.heading.replace(/&[a-z]+;/g, '')}
                      </a>
                    ))}
                  </nav>
                </div>
              </aside>

              <div className="lg:flex-1 max-w-[760px] mx-auto lg:mx-0">
                {article.sections.map((section) => (
                  <section key={section.id} id={section.id} className="mb-12">
                    <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4" dangerouslySetInnerHTML={{ __html: section.heading }} />
                    {section.paragraphs?.map((p, i) => (
                      <p key={i} className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4" dangerouslySetInnerHTML={{ __html: p }} />
                    ))}

                    {section.table && (
                      <div className="overflow-x-auto mb-6">
                        <table className="w-full text-sm border-collapse">
                          <thead>
                            <tr className="border-b border-background-200">
                              {section.table.headers.map((h, i) => (
                                <th key={i} className={`text-left py-3 px-4 font-semibold ${i === 1 ? 'text-primary-600' : 'text-foreground-900'}`}>
                                  {h}
                                </th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {section.table.rows.map((row, ri) => (
                              <tr key={ri} className="border-b border-background-200/60">
                                {row.map((cell, ci) => (
                                  <td key={ci} className={`py-3 px-4 ${ci === 1 ? 'text-primary-600 font-semibold' : 'text-foreground-600'}`}>
                                    {cell}
                                  </td>
                                ))}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}

                    {section.steps && (
                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
                        {section.steps.map((item) => (
                          <div key={item.step} className="bg-background-100 rounded-xl p-5 border border-background-200/60">
                            <span className="inline-flex w-8 h-8 items-center justify-center rounded-full bg-primary-500 text-white text-sm font-bold mb-3">
                              {item.step}
                            </span>
                            <h3 className="text-base font-heading font-bold text-foreground-950 mb-2" dangerouslySetInnerHTML={{ __html: item.title }} />
                            <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                          </div>
                        ))}
                      </div>
                    )}

                    {section.list && (
                      <ul className="space-y-3 mb-6">
                        {section.list.map((item) => (
                          <li key={item.title} className="flex gap-3">
                            <span className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5 text-accent-600">
                              <i className="ri-checkbox-circle-fill"></i>
                            </span>
                            <div>
                              <strong className="text-sm text-foreground-900" dangerouslySetInnerHTML={{ __html: item.title }} />
                              <span className="text-sm text-foreground-600"> {item.text}</span>
                            </div>
                          </li>
                        ))}
                      </ul>
                    )}

                    {section.tip && (
                      <div className="bg-accent-50 border border-accent-200/60 rounded-xl p-5 mb-6">
                        <p className="text-sm text-accent-800 font-semibold mb-2">
                          <span className="w-4 h-4 inline-flex items-center justify-center mr-1">
                            <i className="ri-lightbulb-line"></i>
                          </span>
                          Tipp der OOPBUY Redaktion:
                        </p>
                        <p className="text-sm text-accent-700 leading-relaxed" dangerouslySetInnerHTML={{ __html: section.tip }} />
                      </div>
                    )}

                    {section.faqs && (
                      <div className="space-y-3">
                        {section.faqs.map((faq, i) => (
                          <div key={i} className="bg-background-100 rounded-xl p-5 border border-background-200/60">
                            <h3 className="text-sm font-heading font-bold text-foreground-950 mb-2">{faq.q}</h3>
                            <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                          </div>
                        ))}
                      </div>
                    )}
                  </section>
                ))}

                <div className="mt-10 p-6 md:p-8 bg-primary-50 rounded-2xl border border-primary-200/60 text-center">
                  <h3 className="text-xl font-heading font-bold text-foreground-950 mb-3">
                    Bereit f&uuml;r Ihr OOPBUY Spreadsheet Erlebnis?
                  </h3>
                  <p className="text-sm text-foreground-600 mb-5 max-w-md mx-auto">
                    Entdecken Sie jetzt alle Kategorien auf kaspreadsheet.com und starten Sie sicher und einfach in die Welt des internationalen Online-Shoppings.
                  </p>
                  <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                    <a
                      href="https://kaspreadsheet.com"
                      target="_blank"
                      rel="noopener nofollow"
                      className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-white text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap"
                    >
                      OOPBUY Spreadsheet
                      <span className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-arrow-right-line"></i>
                      </span>
                    </a>
                    <Link
                      to="/"
                      className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-background-100 border border-background-300 text-foreground-800 text-sm font-semibold hover:bg-background-200 transition-colors whitespace-nowrap"
                    >
                      Zur&uuml;ck zur Startseite
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </article>
      </main>
      <Footer />
    </>
  );
}